export default __webpack_public_path__ + "static/media/react.876c9455.png";